<template lang="html">
  <v-layout row wrap justify-center align-center style="height: 100vh;">
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <ErrorAlert :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>
    <Addbot :BotDetail="BotDetail" :AddbotDialog="AddbotDialog" @closeComponents="closeComponents"/>
  </v-layout>
</template>

<script>
import ErrorAlert from '@/components/Alert/Error'
import Addbot from '@/components/Addbot'
export default {
  data() {
    return {
      BotDetail: {},
      AddbotDialog: false,
      overlay: true,
      business_id: '',
      ErrorDialog: false,
      ErrorDialogDetail: {},
    }
  },
  components: {
    ErrorAlert,
    Addbot
  },
  created() {
    // console.log(this.parseJwt(key))
    // this.parseJwt(key)
    this.$cookie.delete('user-profile')
    this.$cookie.delete('login-page')
    this.$cookie.delete('one_token')
    localStorage.clear()
    var shared_token = this.$route.query.shared_token
    var bot_id = this.$route.query.bot_id
    if (this.$route.query.login_page !== undefined) {
      this.$cookie.set('login-page', 'true')
      this.$cookie.set('one_token', this.$route.query.one_token)
    }

    if (this.$route.query.app_lang !== undefined) {
      this.$cookie.set('language', this.$route.query.app_lang)
    } else {
      this.$cookie.set('language', 'th')
    }
    this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
    if (this.$route.query.bot_id !== undefined) {
      this.checkAuthenWhitBot(shared_token, bot_id)
    } else {
      this.checkAuthen(shared_token)
    }
  },
  methods: {
    closeComponents (data) {
      if (data.name === 'detail-bot') {
        this.$router.push('/homepage')
        // this.AddbotDialog = data.value
      }
    },
    closeAlertDialog (data) {
      // console.log(data)
      if (data.type === 'err') {
        this.ErrorDialog = data.value
      }
    },
    checkAuthenWhitBot (key, botid) {
      this.axios.post(process.env.VUE_APP_API_MANAGE + `/v2/login_sharedtoken`, {
        shared_token: key
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.overlay = false
          var profile = response.data['account']['profile']
          this.$cookie.set('user-profile', JSON.stringify(response.data))
          localStorage.setItem('user-profile', JSON.stringify(response.data))
          this.axios.post(process.env.VUE_APP_API_GO + `/v1/bot-search-friend`, {
            tokenbot: botid,
            tokenuser: profile['tokenuser']
          }).then((responsed) => {
            // console.log(responsed.data)
            if (responsed.data.listuser.relation === 'friend') {
              this.$cookie.set('select_menu', 2) // เซตเมนูให้อยู่แท็บ listchat
              // mark read ก่อนเข้าห้องแชท
              this.axios.post(process.env.VUE_APP_API_alpine + '/v1/user-mark-read', {tokenuser: response.data['account']['profile'].tokenuser, tokenroom: this.$route.query.tokenrooom}).then((response) => {
              })
              this.$router.push(`/chat/${responsed.data.listuser.user.tokenroom}?backstatus=${this.$route.query.backstatus}`)
            } else {
              this.BotDetail = responsed.data.listuser
              this.AddbotDialog = true
              // this.$router.push('/homepage')
            }
          }).catch(err => {
            console.log(err.response.data)
          })
        } else {
          // alert(response.data.status)
          this.overlay = false

          if (this.$cookie.get('login-page') === 'true') {
            this.$cookie.delete('login-page')
            this.$cookie.delete('one_token')
            window.open(`${process.env.VUE_APP_URL_PRIVATE}/login`, '_self')
          }
          this.ErrorDialogDetail = {
            title: 'Error',
            text: response.data.message
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.overlay = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: err.response.data.message
        }
        this.ErrorDialog = true
      })
    },
    async checkAuthen(key) {
      this.overlay = true
      await this.axios.post(process.env.VUE_APP_API_MANAGE + `/v2/login_sharedtoken`, {
        shared_token: key
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.overlay = false
          // console.log(JSON.stringify(response.data))
          this.$cookie.set('user-profile', JSON.stringify(response.data))
          localStorage.setItem('user-profile', JSON.stringify(response.data))
          // var me = this
          // setTimeout(function() {
          //   me.$cookie.set('user-profile', JSON.stringify(response.data.data))
          // }, 2000);
          // console.log(JSON.parse(localStorage.getItem('user-profile')))
          // console.log(JSON.parse(this.$cookie.get('user-profile')))
          // console.log(this.$route.query.type)
          if (this.$route.query.type === 'Message') {
            // console.log(this.$route.query.tokenrooom)
            // console.log(this.$route.query.backstatus)
            this.$cookie.set('select_menu', 2) // เซตเมนูให้อยู่แท็บ listchat
            // mark read ก่อนเข้าห้องแชท
            this.axios.post(process.env.VUE_APP_API_alpine + '/v1/user-mark-read', {tokenuser: response.data['account']['profile'].tokenuser, tokenroom: this.$route.query.tokenrooom}).then((response) => {
            })
            this.$router.push(`/chat/${this.$route.query.tokenrooom}?backstatus=${this.$route.query.backstatus}`)
          } else {
            this.$router.push('/homepage')
          }
        } else {
          // alert(response.data.status)
          this.ErrorDialogDetail = {
            title: 'Error',
            text: response.data.message
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.overlay = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: err.response.data.message
        }
        this.ErrorDialog = true
      })
    },
    parseJwt (token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      var authen = JSON.parse(jsonPayload)
      this.checkAuthen(authen.access_token)
      // return JSON.parse(jsonPayload);
    },
  }
}
</script>

<style lang="css" scoped>
</style>
